// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".modal.modal--newyearmodal{max-width:480px;padding-bottom:0}.new-year-modal__text{font-weight:normal;font-size:16px;line-height:24px;margin:16px 0;font-weight:500;color:#fff}.new-year-modal .button{background:#cd1320 !important}.new-year-modal .button:hover{background:#ec2b2d !important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
